var ContactsComponent;

(function ($) {
	var mixinContacts = {
		methods: {
			messages: function(response) {
				if(response.body.status === 'ok') {
					this.sendFormMessage = {
						sended: true,
						class: 'form__message--success',
						message: 'Сообщение успешно отправлено'
					}
				}

				if(response.body.status === 'bad') {
					this.sendFormMessage = {
						sended: true,
						class: 'form__message--error',
						message: 'Произошла ошибка при отправке сообщения'
					}
				}
			}
		}
	};

	var RentFormComponent = Vue.component('rent-form', {
		template: '#rent-form',
		mixins: [mixinContacts],
		validations: {
			name: {
				required: validators.required
			},
			post: {
				required: validators.required
			},
			phone: {
				required: validators.required
			},
			email: {
				required: validators.required
			},
			goodProfile: {
				required: validators.required
			},
			marks: {
				required: validators.required
			},
			from: {
				required: validators.required
			},
			to: {
				required: validators.required
			}
		},
		data: function() {
			return {
				slider: '',
				name: '',
				post: '',
				address: '',
				phone: '',
				fax: '',
				email: '',
				website: '',
				nameCompany: '',
				franchising: 'yes',
				goodProfile: '',
				marks: '',
				countries: '',
				nameShops: '',
				rostov: '',
				msk: '',
				russia: '',
				count: '',
				shopCenter: '',
				addressShop: '',
				proceeds: '',
				age: '',
				price: '',
				check: '',
				from: '',
				to: '',
				optimal: '',
				floor0: true,
				floor1: false,
				floor2: false,
				floorOver: false,
				nameShop: '',
				send: {
					name: {error: false},
					post: {error: false},
					phone: {error: false},
					email: {error: false},
					goodProfile: {error: false},
					marks: {error: false},
					from: {error: false},
					to: {error: false},
					floor: {error: false},
				},
				sendButton: false,
				sendFormMessage: {
					sended: false
				}
			}
		},
		methods: {
			clearForm: function() {
				this.slider.slideTo(0,0);

				this.name = '';
				this.post = '';
				this.address = '';
				this.phone = '';
				this.fax = '';
				this.email = '';
				this.website = '';
				this.nameCompany = '';
				this.franchising = 'yes';
				this.profile = '';
				this.goodProfile = '';
				this.marks = '';
				this.countries = '';
				this.nameShops = '';
				this.rostov = '';
				this.msk = '';
				this.russia = '';
				this.count = '';
				this.shopCenter = '';
				this.addressShop = '';
				this.proceeds = '';
				this.age = '';
				this.price = '';
				this.check = '';
				this.from = '';
				this.to = '';
				this.optimal = '';
				this.floor0 = true;
				this.floor1 = false;
				this.floor2 = false;
				this.floorOver = false;

				this.date = '';
				this.nameShop = '';

				this.send.name.error = false;
				this.send.post.error = false;
				this.send.phone.error = false;
				this.send.email.error = false;
				this.send.goodProfile.error = false;
				this.send.marks.error = false;
				this.send.from.error = false;
				this.send.to.error = false;
				this.send.floor.error = false;

				this.sendButton = false;
				this.sendFormMessage.sended = false;

				var $box = $('.box_blockContacts .tabsContent_4'),
					$form = $box.find('.form_requestForm'),
					$checkForm = $form.find('.checkForm');

				$checkForm.removeClass('disabled');
			},

			sendForm: function() {
				this.sendButton = true;

				var sendData = {
					action: 'rent-form',
					name: this.name,
					post: this.post,
					address: this.address,
					phone: this.phone,
					fax: this.fax,
					email: this.email,
					website: this.website,
					nameCompany: this.nameCompany,
					franchising: this.franchising,
					profile: $('.tabsContent_4 .form__select').find('option:selected').val(),
					goodProfile: this.goodProfile,
					marks: this.marks,
					countries: this.countries,
					nameShops: this.nameShops,
					rostov: this.rostov,
					msk: this.msk,
					russia: this.russia,
					count: this.count,
					shopCenter: this.shopCenter,
					addressShop: this.addressShop,
					proceeds: this.proceeds,
					age: this.age,
					price: this.price,
					check: this.check,
					from: this.from,
					to: this.to,
					optimal: this.optimal,
					floor0: this.floor0,
					floor1: this.floor1,
					floor2: this.floor2,
					floorOver: this.floorOver,

					date: $('.tabsContent_4 .datepicker').val(),
					nameShop: this.nameShop
				};

				if(this.checkForm()) {
					this.$http
						.post('', sendData, // get /json/testForm.json
						{
							emulateJSON: true
						})
						.then(function(response) {
							// this.messages(response);
							$.fancybox.close(true);
							$.fancybox.open($('#thanksPopup'), {
								baseClass : 'thanks-popup'
							});
							this.clearForm();
						},
						function(error) {
							console.log('send error');

							this.sendFormMessage = {
								sended: true,
								class: 'form__message--error',
								message: 'Произошла ошибка при отправке сообщения'
							}
						});
				}
				else {
					this.sendFormMessage.sended = false;
				}
			},

			checkNext: function() {
				this.checkForm();

				this.$nextTick(function() {
					var $box = $('.box_blockContacts .tabsContent_4'),
						$form = $box.find('.form_requestForm'),
						$activeSlide = $form.find('.swiper-slide-active'),
						$checkForm = $form.find('.checkForm'),
						index = $activeSlide.data('index') || 0;

					if (index == 0) {
						if(!this.$v.name.$invalid && !this.$v.post.$invalid && !this.$v.phone.$invalid && !this.$v.email.$invalid) {
							$checkForm.addClass('disabled');
						} else {
							$checkForm.removeClass('disabled');
						}
					} else if (index == 2) {
						if(!this.$v.goodProfile.$invalid && !this.$v.marks.$invalid) {
							$checkForm.addClass('disabled');
						} else {
							$checkForm.removeClass('disabled');
						}
					} else if (index == 5) {
						if((!this.$v.from.$invalid && !this.$v.to.$invalid) && (this.floor0 || this.floor1 || this.floor2 || this.floorOver)) {
							$checkForm.addClass('disabled');
						} else {
							$checkForm.removeClass('disabled');
						}

					} else if ((index == 1) || (index == 3) || (index == 4)) {
						$checkForm.addClass('disabled');
					}
				});
			},

			checkForm: function() {
				if(this.$v.name.$invalid) {
					this.send.name = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'ФИО контактного лица'
					};
				}
				else {
					this.send.name = {
						error: false
					};
				}

				if(this.$v.post.$invalid) {
					this.send.post = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'Должность контактного лица'
					};
				}
				else {
					this.send.post = {
						error: false
					};
				}

				if(this.$v.phone.$invalid) {
					this.send.phone = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'Контактные телефоны'
					};
				}
				else {
					this.send.phone = {
						error: false
					};
				}

				if(this.$v.email.$invalid) {
					this.send.email = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'E-mail'
					};
				}
				else {
					this.send.email = {
						error: false
					};
				}

				if(this.$v.goodProfile.$invalid) {
					this.send.goodProfile = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'Товарный профиль магазина'
					};
				}
				else {
					this.send.goodProfile = {
						error: false
					};
				}

				if(this.$v.marks.$invalid) {
					this.send.marks = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'Товарные марки'
					};
				}
				else {
					this.send.marks = {
						error: false
					};
				}

				if(this.$v.from.$invalid || this.$v.to.$invalid) {
					this.send.from = {
						error: true,
						class: 'form__message--error',
						message: 'Поля обязательны для заполнения',
						name: 'Размер аренды торговой площади'
					};
				}
				else {
					this.send.from = {
						error: false
					};
				}

				if(!this.floor0 && !this.floor1 && !this.floor2 && !this.floorOver) {
					this.send.floor = {
						error: true,
						class: 'form__message--error',
						message: 'Выберите этаж',
						name: 'Этаж'
					};
				}
				else {
					this.send.floor = {
						error: false
					};
				}

				return !this.$v.$invalid;
			},

			scriptsInit: function() {
				var $form = $('.tabsContent_4 .form_requestForm'),
						$slides = $form.find('.swiper-slide'),
						$datepicker = $form.find('.datepicker');

				if($form) {
					//$('.form__label.phone input').mask('+7 (999) 999-99-99');

					$datepicker.datepicker({
						showAnim: 'fade',
						dateFormat: "dd/mm/yy"
					});

					// --- selectric ----
					var $select = $form.find('.form__select');

					$select.selectric({
						arrowButtonMarkup: '<svg class="selectric-select__arrow" width="16" height="8"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#down-arrow"></use></svg>'
					});

					$select.on('selectric-open', function(event, element, selectric) {
						$(element)
							.parents('.selectric-wrapper')
							.find('.selectric-select__arrow')
							.addClass('selectric-select__arrow--open');
					});

					$select.on('selectric-close', function(event, element, selectric) {
						$(element)
							.parents('.selectric-wrapper')
							.find('.selectric-select__arrow')
							.removeClass('selectric-select__arrow--open');
					});

					this.slider = new Swiper($form.find('.swiper-container'), {
						effect: 'fade',
						nextButton: $form.find('.swiper-button-next'),
						prevButton: $form.find('.swiper-button-prev'),
						simulateTouch: false
					});

					$.each($slides, function() {
						$(this).mCustomScrollbar();
					});
				}
			}
		},
		mounted: function() {
			this.scriptsInit();
		}
	});

	var TestimonialFormComponent = Vue.component('testimonial-form', {
		template: '#testimonial-form',
		props: ['type'],
		mixins: [mixinContacts],
		data: function() {
			return {
				name: '',
				phone: '',
				email: '',
				message: '',
				sendFormMessage: {
					sended: false
				}
			}
		},
		methods: {
			clearForm: function() {
				this.name = '';
				this.phone = '';
				this.email = '';
				this.message = '';
				this.sendFormMessage.sended = false;
			},

			sendForm: function(type) {
				type = type || '';

				this.$http
					.post('', { // get /json/testForm.json
							name: this.name,
							phone: this.phone,
							email: this.email,
							message: this.message,
							action: type
						},
						{
							emulateJSON: true
						})
					.then(function(response) {
						// this.messages(response);
						$.fancybox.close(true);
						$.fancybox.open($('#thanksPopup'), {
							baseClass : 'thanks-popup'
						});
						this.clearForm();
					},
					function(error) {
						console.log('send error');

						this.sendFormMessage = {
							sended: true,
							class: 'form__message--error',
							message: 'Произошла ошибка при отправке сообщения'
						}
					});
			},

			setPhone: function() {
				// какая дичь!!!
				// костыль поменьше - получать значения напрямую через js
				this.phone = this.$refs.temp.value;
			}
		}
	});


	// --------------- for mobile -----------------
	var AdvertisingComponent = Vue.component('contacts-advertising-vue', {
		template: '#contacts-advertising-vue',
		props: ['showDetail', 'closeDetail']
	});

	var RentComponent = Vue.component('contacts-rent-vue', {
		template: '#contacts-rent-vue',
		props: ['showDetail', 'closeDetail']
	});

	var RentFormComponentMobile = Vue.component('rent-form-mobile', {
		template: '#rent-form-mobile',
		mixins: [mixinContacts],
		validations: {
			name: {
				required: validators.required
			},
			post: {
				required: validators.required
			},
			phone: {
				required: validators.required
			},
			email: {
				required: validators.required
			},
			goodProfile: {
				required: validators.required
			},
			marks: {
				required: validators.required
			},
			from: {
				required: validators.required
			},
			to: {
				required: validators.required
			}
		},
		data: function() {
			return {
				slider: '',
				name: '',
				post: '',
				address: '',
				phone: '',
				fax: '',
				email: '',
				website: '',
				nameCompany: '',
				franchising: 'yes',
				goodProfile: '',
				marks: '',
				countries: '',
				nameShops: '',
				rostov: '',
				msk: '',
				russia: '',
				count: '',
				shopCenter: '',
				addressShop: '',
				proceeds: '',
				age: '',
				price: '',
				check: '',
				from: '',
				to: '',
				floor0: true,
				floor1: false,
				floor2: false,
				floorOver: false,
				optimal: '',
				nameShop: '',
				send: {
					name: {error: false},
					post: {error: false},
					phone: {error: false},
					email: {error: false},
					goodProfile: {error: false},
					marks: {error: false},
					from: {error: false},
					to: {error: false},
					floor: {error: false},
				},
				sendButton: false,
				sendFormMessage: {
					sended: false
				}
			}
		},
		methods: {
			clearForm: function() {
				this.slider.slideTo(0,0);

				this.name = '';
				this.post = '';
				this.address = '';
				this.phone = '';
				this.fax = '';
				this.email = '';
				this.website = '';
				this.nameCompany = '';
				this.franchising = 'yes';
				this.profile = '';
				this.goodProfile = '';
				this.marks = '';
				this.countries = '';
				this.nameShops = '';
				this.rostov = '';
				this.msk = '';
				this.russia = '';
				this.count = '';
				this.shopCenter = '';
				this.addressShop = '';
				this.proceeds = '';
				this.age = '';
				this.price = '';
				this.check = '';
				this.from = '';
				this.to = '';
				this.optimal = '';
				this.floor0 = true;
				this.floor1 = false;
				this.floor2 = false;
				this.floorOver = false;
				this.date = '';
				this.nameShop = '';

				this.send.name.error = false;
				this.send.post.error = false;
				this.send.phone.error = false;
				this.send.email.error = false;
				this.send.goodProfile.error = false;
				this.send.marks.error = false;
				this.send.from.error = false;
				this.send.to.error = false;
				this.send.floor.error = false;

				this.sendButton = false;
				this.sendFormMessage.sended = false;

				var $box = $('.blockContactsRent'),
					$inner = $box.find('.blockContactsRent__inner'),
					$form = $box.find('.form_requestForm'),
					$checkForm = $form.find('.checkForm');

				$checkForm.removeClass('disabled');
				$inner.scrollTop(0);
			},

			sendForm: function() {
				this.sendButton = true;

				var sendData = {
					action: 'rent-form',
					name: this.name,
					post: this.post,
					address: this.address,
					phone: this.phone,
					fax: this.fax,
					email: this.email,
					website: this.website,
					nameCompany: this.nameCompany,
					franchising: this.franchising,
					profile: $('.blockContactsRent .form__select[name="profile"]').val(),
					goodProfile: this.goodProfile,
					marks: this.marks,
					countries: this.countries,
					nameShops: this.nameShops,
					rostov: this.rostov,
					msk: this.msk,
					russia: this.russia,
					count: this.count,
					shopCenter: this.shopCenter,
					addressShop: this.addressShop,
					proceeds: this.proceeds,
					age: this.age,
					price: this.price,
					check: this.check,
					from: this.from,
					to: this.to,
					optimal: this.optimal,
					floor0: this.floor0,
					floor1: this.floor1,
					floor2: this.floor2,
					floorOver: this.floorOver,
					date: $('.blockContactsRent .datepicker').val(),
					nameShop: this.nameShop
				};

				if(this.checkForm()) {
					this.$http
						.post('', sendData,  // get /json/testForm.json
						{
							emulateJSON: true
						})
						.then(function(response) {
							// this.messages(response);
							app.utils.menuClose();
							$('.thanksPopupMobile').addClass('open');
							$('html, body').addClass('overflow--thanks');

							this.clearForm();
						},
						function(error) {
							console.log('send error');

							this.sendFormMessage = {
								sended: true,
								class: 'form__message--error',
								message: 'Произошла ошибка при отправке сообщения'
							}
						});
				}
				else {
					this.sendFormMessage.sended = false;
				}
			},

			checkNext: function() {
				this.checkForm();

				this.$nextTick(function() {
					var $box = $('.blockContactsRent'),
						$form = $box.find('.form_requestForm'),
						$activeSlide = $form.find('.swiper-slide-active'),
						$checkForm = $form.find('.checkForm'),
						index = $activeSlide.data('index') || 0;

					if (index == 0) {
						if(!this.$v.name.$invalid && !this.$v.post.$invalid && !this.$v.phone.$invalid && !this.$v.email.$invalid) {
							$checkForm.addClass('disabled');
						} else {
							$checkForm.removeClass('disabled');
						}
					} else if (index == 2) {
						if(!this.$v.goodProfile.$invalid && !this.$v.marks.$invalid) {
							$checkForm.addClass('disabled');
						} else {
							$checkForm.removeClass('disabled');
						}
					} else if (index == 5) {
						if ((!this.$v.from.$invalid && !this.$v.to.$invalid) && (this.floor0 || this.floor1 || this.floor2 || this.floorOver)) {
							$checkForm.addClass('disabled');
						} else {
							$checkForm.removeClass('disabled');
						}

					} else if ((index == 1) || (index == 3) || (index == 4)) {
						$checkForm.addClass('disabled');
					}
				});
			},

			checkForm: function() {
				if(this.$v.name.$invalid) {
					this.send.name = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'ФИО контактного лица'
					};
				}
				else {
					this.send.name = {
						error: false
					};
				}

				if(this.$v.post.$invalid) {
					this.send.post = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'Должность контактного лица'
					};
				}
				else {
					this.send.post = {
						error: false
					};
				}

				if(this.$v.phone.$invalid) {
					this.send.phone = {
						error: true,
						class: 'form__message--error',
						message: 'Введите контактные телефоны. Например: +7(900)000-00-00',
						name: 'Контактные телефоны'
					};
				}
				else {
					this.send.phone = {
						error: false
					};
				}

				if(this.$v.email.$invalid) {
					this.send.email = {
						error: true,
						class: 'form__message--error',
						message: 'Введите e-mail. Например: example@mail.ru',
						name: 'E-mail'
					};
				}
				else {
					this.send.email = {
						error: false
					};
				}

				if(this.$v.goodProfile.$invalid) {
					this.send.goodProfile = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'Товарный профиль магазина'
					};
				}
				else {
					this.send.goodProfile = {
						error: false
					};
				}

				if(this.$v.marks.$invalid) {
					this.send.marks = {
						error: true,
						class: 'form__message--error',
						message: 'Поле обязательно для заполнения',
						name: 'Товарные марки'
					};
				}
				else {
					this.send.marks = {
						error: false
					};
				}

				if(this.$v.from.$invalid || this.$v.to.$invalid) {
					this.send.from = {
						error: true,
						class: 'form__message--error',
						message: 'Поля обязательны для заполнения',
						name: 'Размер аренды торговой площади'
					};
				}
				else {
					this.send.from = {
						error: false
					};
				}

				if(!this.floor0 && !this.floor1 && !this.floor2 && !this.floorOver) {
					this.send.floor = {
						error: true,
						class: 'form__message--error',
						message: 'Выберите этаж',
						name: 'Этаж'
					};
				}
				else {
					this.send.floor = {
						error: false
					};
				}

				return !this.$v.$invalid;
			},

			scriptsInit: function() {
				var $box = $('.blockContactsRent'),
					$inner = $box.find('.blockContactsRent__inner'),
					$form = $box.find('.form_requestForm'),
					$slides = $form.find('.swiper-slide'),
					$thanksPopupMobile = $('.thanksPopupMobile'),
					$buttonBack = $box.find('.buttonBack'),
					$close = $thanksPopupMobile.find('.js-thanksClose'),
					that = this;

				$form.on('keyup input', function(){
					that.checkNext();
				});

				$close.on('click', function(){
					$thanksPopupMobile.removeClass('open');
					$('html, body').removeClass('overflow--thanks');
				});

				$buttonBack.on('click', function() {
					that.clearForm();
				});

				if($form) {
					//$('.form__label.phone input').mask('+7 (999) 999-99-99');

					$('.datepicker').datepicker({
						showAnim: 'fade',
						dateFormat: "dd/mm/yy"
					});

					// --- selectric ----
					var $select = $('.form__select');

					$select.selectric({
						arrowButtonMarkup: '<svg class="selectric-select__arrow" width="16" height="8"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#down-arrow"></use></svg>'
					});

					$select.on('selectric-open', function(event, element, selectric) {
						$(element)
							.parents('.selectric-wrapper')
							.find('.selectric-select__arrow')
							.addClass('selectric-select__arrow--open');
					});

					$select.on('selectric-close', function(event, element, selectric) {
						$(element)
							.parents('.selectric-wrapper')
							.find('.selectric-select__arrow')
							.removeClass('selectric-select__arrow--open');
					});

					this.slider = new Swiper($form.find('.swiper-container'), {
						simulateTouch: false,
						onlyExternal: true,
						effect: 'slide',
						nextButton: $form.find('.swiper-button-next'),
						prevButton: $form.find('.swiper-button-prev'),
						onSlideChangeStart: function() {
							$inner.scrollTop(0);
						}
					});
				}
			}
		},
		mounted: function() {
			this.scriptsInit();
		}
	});

	var TestimonialFormMobile = Vue.component('testimonial-form-mobile', {
		template: '#testimonial-form-mobile',
		props: ['type'],
		mixins: [mixinContacts],
		data: function() {
			return {
				name: '',
				phone: '',
				email: '',
				message: '',
				sendFormMessage: {
					sended: false
				}
			}
		},
		mounted: function() {
			this.scriptsInit();
		},
		methods: {
			clearForm: function() {
				this.name = '';
				this.phone = '';
				this.email = '';
				this.message = '';
				this.sendFormMessage.sended = false;
			},

			sendForm: function(type) {
				type = type || '';

				this.$http
					.post('', { // get /json/testForm.json
							name: this.name,
							phone: this.phone,
							email: this.email,
							message: this.message,
							action: type
						},
						{
							emulateJSON: true
						})
					.then(function(response) {
						app.utils.menuClose();
						$('.thanksPopupMobile').addClass('open');
						$('html, body').addClass('overflow--thanks');

						this.clearForm();
						// this.messages(response);
					},
					function(error) {
						console.log('send error');

						this.sendFormMessage = {
							sended: true,
							class: 'form__message--error',
							message: 'Произошла ошибка при отправке сообщения'
						}
					});
			},

			setPhone: function() {
				// какая дичь!!!
				// костыль поменьше - получать значения напрямую через js
				this.phone = this.$refs.temp.value;
			},

			scriptsInit: function() {
				var $box = $('.blockContactsAdvertising'),
					$thanksPopupMobile = $('.thanksPopupMobile'),
					$buttonBack = $box.find('.buttonBack'),
					$close = $thanksPopupMobile.find('.js-thanksClose'),
					that = this;


				$close.on('click', function(){
					$thanksPopupMobile.removeClass('open');
					$('html, body').removeClass('overflow--thanks');
				});

				$buttonBack.on('click', function() {
					that.clearForm();
				});
			}
		}
	});

	var ThanksPopupMobile = Vue.component('thanks-mobile-vue', {
		template: '#thanks-mobile-vue',
		props: []
	});
	// - for mobile -end


	ContactsComponent = Vue.component('contacts-vue', {
		template: '#contacts-vue',
		data: function() {
			return {
				values: [],
				about: [],
				advertising: [],
				contacts: [],
				rent: [],
				testimonials: [],
				hideSpinner: false
			}
		},
		components: {
			TestimonialFormComponent: TestimonialFormComponent,
			RentFormComponent: RentFormComponent,
			RentComponent: RentComponent,
			RentFormComponentMobile: RentFormComponentMobile,
			TestimonialFormMobile: TestimonialFormMobile,
			AdvertisingComponent: AdvertisingComponent,
			ThanksPopupMobile: ThanksPopupMobile
		},

		mounted: function() {
			this.mobile();
		},

		methods: {
			mobile: function() {
				var isMobile = function() {
					if (app.sizes.width < app.mobileTo) {
						$('.content').append($('.blockContactsAdvertising'));
						$('.content').append($('.blockContactsRent'));
						$('.content').append($('.thanksPopupMobile'));
					}
				};
				isMobile();
			},

			getData: function() {
				var url = '/static/components-assets/blockContacts/data.json';

				if(CommonHelpers.isDev('gold-babylon-static.denode.ru'))
					url = 'static/components-assets/blockContacts/data.json';

				if(!this.values.length) {
					this.$http
						.get(url, {
							params: {
								action: 'getContacts'
							}
						})
						.then(function(response) {
								var data = response.body.data,
										that = this;

								this.values = data;

								this.about = data.about;
								this.advertising = data.advertising;
								this.contacts = data.contacts;
								this.rent = data.rent;
								this.testimonials = data.testimonials;

								var objImages = [{
									loaded: false,
									src: data.contacts.img
								}];

								CommonHelpers.checkImgLoading(objImages)
									.then(function() {
										that.doAnimation();
									});

								this.$nextTick(function() {
									this.scriptsInit();
								});
							},
							function(response) { // Error.
								console.log('An error occurred.');
							}
						);
				}
			},

			doAnimation: function() {
				var $targetSlide = $('.tabs');
				$targetSlide.find('.fade-button').showItem(150);

				this.hideSpinner = true;
			},

			scriptsInit: function() {
				$('.form__label.phone input').mask('+7 (999) 999-99-99');

				if (!$('.contactsMap').hasClass('loaded')) {
					YaHelpers
						.initMap('contactsMap', initMapConfig)
						.then(function() {
							YaHelpers.addAllPlacemarks(initMapConfig.coords);
						});
				};
				$('.contactsMap').on('mousewheel', function(event) {
					event.stopPropagation();
				});

				var $partner = $('.blockContactsPartner');

				$.each($partner, function() {
					var $wrapTab = $(this),
						$wrapCont = $wrapTab.find('.blockContactsPartner__contentBox'),
						$tabsContent = $wrapCont.find('.blockContactsPartner__content'),
						$navItems =  $wrapTab.find('.blockContactsPartnerNav__item');

					$navItems.on('click', function() {
						var id = $(this).data('id');

						$navItems.removeClass('active');
						$(this).addClass('active');
						$tabsContent.removeClass('active');
						$tabsContent.filter('[data-id="'+id+'"]').addClass('active');
					});
				});
			},

			showDetail: function(type) {
				var that = this;

				if (type == 'rent') {
					$('.blockContactsRent').addClass('open');
				} else {
					$('.blockContactsAdvertising').addClass('open');

					var detail = document.getElementById('blockContactsAdvertising');
					var mc = new Hammer(detail);

					mc.on('swiperight', function() {
						that.closeDetail();
					});
				}

				setTimeout(function(){
					$('html, body').addClass('overflow--detail');
				}, 500);
			},

			closeDetail: function(type) {
				$('html, body').removeClass('overflow--detail');
				$(window).scrollTop($('.box_blockContacts').offset().top - $('.header__left').outerHeight());

				if (type == 'rent') $('.blockContactsRent').removeClass('open');
				else $('.blockContactsAdvertising').removeClass('open');
			}
		}
	});
})(jQuery);
